/* assets/atelier.js — v3.1 (Maison Berbère)
   - Nuancier embarqué complet (fallback) + fetch si dispo
   - Finitions : images plus petites, centrées, s’affichent SOUS les bulles
   - Boutons fichiers (croquis/références) avec emoji + nom de fichier
*/
(function () {
  /* ================= PARAMÈTRES ================= */
  const PRIX_M2 = { mrirt: 299, beni_ouarain: 219, azilal: 239 }; // €/m² HT
  const TVA = 0.20;
  const FORFAIT_DESIGN = 300;
  const INCLURE_FORFAIT_DESIGN = true;
  const PRIX_FRANGE_PREMIUM = 40;
  const PRIX_BORDURE_BINDING = 40;
  const ARRONDI_TTC = 'NEUF_PLUS_PROCHE'; // 'AUCUN' | 'NEUF_PLUS_PROCHE' | 'NEUF_SUP'
  const FRAIS_TRANSPORT_INCLUS = 0;
  const MAX_COLORS = 5;

  const PRICING = {
    rate_m2: PRIX_M2,
    TVA,
    FORFAIT_DESIGN,
    INCLURE_FORFAIT_DESIGN,
    finishes: {
      fringes: { classiques: 0, torsadees: PRIX_FRANGE_PREMIUM, bord_tisse: 0 },
      edge: { surjet: 0, galon: PRIX_BORDURE_BINDING },
      symmetry: { asym: 0, sym: 20, modern: 30 }
    },
    FRAIS_TRANSPORT_INCLUS,
    ARRONDI_TTC
  };

  // Mapping des titres pour la prévisualisation
  const FINITION_TITLES = {
    'classiques': 'Franges Classiques',
    'torsadees': 'Franges Torsadées',
    'bord_tisse': 'Bord Tissé',
    'surjet': 'Finition Simple (Surjet)',
    'galon': 'Bordure Tissée (Galon)',
    'asym': 'Style Libre (Asymétrique)',
    'sym': 'Symétrie Parfaite',
    'modern': 'Symétrie Moderne'
  };

  const N8N_WEBHOOK_URL = 'https://ri-com.app.n8n.cloud/webhook/atelier-des-possibles';

  async function sendAtelierDataToN8N(payload) {
    try {
      // Envoi des réponses de l’Atelier vers n8n (PRODUCTION)
      const response = await fetch("https://ri-com.app.n8n.cloud/webhook/atelier-des-possibles", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        console.error('[Atelier → n8n] Erreur HTTP', response.status, await response.text());
      } else {
        console.log('[Atelier → n8n] Données envoyées avec succès');
      }
    } catch (error) {
      console.error('[Atelier → n8n] Erreur réseau/fetch', error);
    }
  }

  // ═══════════════════════════════════════════════════════════════
  // IMGBB UPLOAD - Hébergement d'images
  // ═══════════════════════════════════════════════════════════════

  const IMGBB_API_KEY = 'fa43660bb607e127433f25fd587bd11b';

  /**
   * Upload un fichier vers ImgBB et retourne l'URL publique
   * @param {File} file - Fichier à uploader
   * @returns {Promise<string|null>} URL publique de l'image ou null si erreur
   */
  async function uploadToImgBB(file) {
    try {
      console.log(`[ImgBB] 📤 Upload de ${file.name}...`);

      const formData = new FormData();
      formData.append('image', file);

      const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        console.error(`[ImgBB] ❌ Erreur HTTP: ${response.status}`);
        return null;
      }

      const data = await response.json();

      if (data.success && data.data && data.data.url) {
        const publicUrl = data.data.url;
        console.log(`[ImgBB] ✅ ${file.name} → ${publicUrl}`);
        return publicUrl;
      } else {
        console.error('[ImgBB] ❌ Réponse invalide:', data);
        return null;
      }

    } catch (error) {
      console.error(`[ImgBB] ❌ Erreur upload ${file.name}:`, error);
      return null;
    }
  }

  /**
   * Upload multiple fichiers vers ImgBB
   * @param {FileList|File[]} files - Liste de fichiers à uploader
   * @returns {Promise<string[]>} Array d'URLs publiques
   */
  async function uploadMultipleToImgBB(files) {
    if (!files || files.length === 0) return [];

    const fileArray = Array.from(files);
    const uploadPromises = fileArray.map(file => uploadToImgBB(file));
    const urls = await Promise.all(uploadPromises);

    // Filtrer les null (échecs d'upload)
    return urls.filter(url => url !== null);
  }

  async function sendToGoogleSheets(formData, fullPayload) {
    try {
      // 1. Extraire les données depuis fullPayload (contient TOUTES les données du configurateur)
      // formData ne contient que les champs du dernier panel visible

      // Couleurs : convertir le tableau palette en chaîne lisible
      const palette = fullPayload?.couleurs?.palette || [];
      const paletteReadable = palette.map(colorObj => {
        if (colorObj.code_nuancier && colorObj.nom) {
          return `${colorObj.code_nuancier} – ${colorObj.nom}`;
        }
        return colorObj.code_nuancier || '';
      }).filter(Boolean).join(' | ') || '';

      // 2.  UPLOAD IMAGES VERS IMGBB ET RÉCUPÉRATION DES URLs
      console.log('[ImgBB] 🔄 Début upload des images...');

      const sketchInput = document.getElementById('ap-sketch');
      const refsInput = document.getElementById('ap-refs');

      let sketchURL = '';
      let refsURLs = '';

      // Upload croquis
      if (sketchInput?.files?.[0]) {
        const url = await uploadToImgBB(sketchInput.files[0]);
        if (url) {
          sketchURL = url;
        }
      }

      // Upload références
      if (refsInput?.files && refsInput.files.length > 0) {
        const urls = await uploadMultipleToImgBB(refsInput.files);
        if (urls.length > 0) {
          refsURLs = urls.join(' | ');
        }
      }

      console.log('[ImgBB] ✅ Upload terminé');
      console.log('[ImgBB] Croquis:', sketchURL || 'Aucun');
      console.log('[ImgBB] Références:', refsURLs || 'Aucune');

      // 3. Finitions : résumé des choix
      const fringeChoice = fullPayload?.finition?.franges?.style || '';
      const edgeChoice = fullPayload?.finition?.bordures?.type || '';
      const symmetryChoice = fullPayload?.finition?.symmetry_description || '';

      const finishingSummary = [
        FINITION_TITLES[fringeChoice] || fringeChoice,
        FINITION_TITLES[symmetryChoice] || symmetryChoice,
        FINITION_TITLES[edgeChoice] || edgeChoice
      ].filter(Boolean).join(' + ');

      // Total estimé
      const estimatedTotal = fullPayload?.estimation?.prix_total_ttc || 0;

      // Notes d'estimation
      const area = fullPayload?.dimensions?.surface_calculee_m2 || 0;
      const baseHT = fullPayload?.estimation?.prix_tapis_ht || 0;
      const optsHT = fullPayload?.estimation?.frais_options_ht || 0;
      const designHT = fullPayload?.estimation?.frais_design_ht || 0;
      const totalHT = fullPayload?.estimation?.prix_total_ht || 0;

      // 2. Payload réorganisé selon l'ORDRE EXACT du Google Sheet
      const googlePayload = {
        // Colonne 1: Date de demande
        date_demande: new Date().toISOString(),

        // Colonne 2: Référence de demande
        reference_demande: fullPayload?.meta?.tmp_request_id || '',

        // Colonne 3: Nom
        nom: fullPayload?.client?.nom_complet || '',

        // Colonne 4: Email
        email: fullPayload?.client?.email || '',

        // Colonne 5: Tel
        tel: fullPayload?.client?.telephone || '',

        // Colonne 6: Rue
        rue: fullPayload?.logistique?.adresse || '',

        // Colonne 7: Ville
        ville: fullPayload?.logistique?.ville || '',

        // Colonne 8: CP
        cp: fullPayload?.logistique?.code_postal || '',

        // Colonne 9: Pays
        pays: fullPayload?.logistique?.pays || '',

        // Colonne 10: Accès
        acces: fullPayload?.logistique?.contraintes_acces || '',

        // Colonne 11: Projet
        projet: fullPayload?.tapis?.type_tapis || 'rug',

        // Colonne 12: Longueur
        longueur: fullPayload?.dimensions?.longueur_cm || '',

        // Colonne 13: Largeur
        largeur: fullPayload?.dimensions?.largeur_cm || '',

        // Colonne 14: Matière
        matiere: fullPayload?.tapis?.matiere_principale || '',

        // Colonne 15: Couleurs
        couleurs: paletteReadable,

        // Colonne 16: Croquis
        croquis: sketchURL,

        // Colonne 17: Références
        references: refsURLs,

        // Colonne 18: Notes création (intention design)
        notes_creation: fullPayload?.projet?.commentaire_global || '',



        // Colonne 19: Frange
        frange: FINITION_TITLES[fringeChoice] || fringeChoice || '',

        // Colonne 20: Symétrie
        symetrie: FINITION_TITLES[symmetryChoice] || symmetryChoice || '',

        // Colonne 21: Bordure
        bordure: FINITION_TITLES[edgeChoice] || edgeChoice || '',

        // Colonne 22: Tarif estimé
        tarif_estime: Math.round(estimatedTotal),

        // Colonne 23: Notes estimations
        notes_estimations: `Surface: ${area.toFixed(2)}m² | Base HT: ${Math.round(baseHT)}€ | Options: ${Math.round(optsHT)}€ | Design: ${designHT}€ | Total HT: ${Math.round(totalHT)}€`
      };

      // 3. Envoi vers Google Apps Script
      await fetch("https://script.google.com/macros/s/AKfycbzSJsRb-x8O0w77N_d-P50wUwhIO4BVxCKKgQx41VTUJpGzSaiErSf0Rv5whuYA6EA/exec", {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(googlePayload)
      });

      console.log('[Atelier → Google Sheets] ✅ Données envoyées');
      console.log('[Atelier → Google Sheets] 📊 Payload:', googlePayload);
    } catch (error) {
      console.error('[Atelier → Google Sheets] ❌ Erreur:', error);
    }
  }

  function formDataToObject(fd) {
    const out = {};
    const normalizeValue = (value) => {
      if (value instanceof File) {
        return value.name || null;
      }
      return value;
    };
    fd.forEach((value, key) => {
      if (Object.prototype.hasOwnProperty.call(out, key)) {
        const current = out[key];
        if (Array.isArray(current)) {
          current.push(normalizeValue(value));
        } else {
          out[key] = [current, normalizeValue(value)];
        }
      } else {
        out[key] = normalizeValue(value);
      }
    });
    return out;
  }

  // Remplace bien cette URL par ton vrai lien de prise de rendez-vous si tu l’utilises
  const GOOGLE_APPT_URL = "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1xFM07CMeBYL3RKd9YXq2aeZzp3-BFasD4c-iYcczLxQ2zK_Ihv3k2kFUwrVPw1U6KfLqHKgaz";

  const PAGE_SIZE_DESKTOP = 24, PAGE_SIZE_TABLET = 16, PAGE_SIZE_MOBILE = 12;

  /* ================= DOM ================= */
  const root = document.getElementById('atelier-des-possibles');
  if (!root) return;
  const form = document.getElementById('ap-form');
  if (!form) return;

  const stepper = document.getElementById('ap-stepper');
  const stepIndexEl = document.getElementById('ap-step-index');
  const stepTitleEl = document.getElementById('ap-step-title');
  const nextHintEl = document.getElementById('ap-next-hint');
  const prevBtn = document.getElementById('ap-prev');
  const nextBtn = document.getElementById('ap-next');
  const submitBtn = document.getElementById('ap-submit');
  const msg = document.getElementById('ap-msg');
  const agenda = document.getElementById('ap-agenda');

  /* Nuancier */
  const swatchGrid = document.getElementById('ap-swatch-grid');
  const swatchSearch = document.getElementById('ap-swatch-search');
  const paletteHidden = document.getElementById('ap-palette-hidden');
  const familyFilter = document.getElementById('ap-family-filter');
  const pagePrev = document.getElementById('ap-page-prev');
  const pageNext = document.getElementById('ap-page-next');
  const pageNote = document.getElementById('ap-page-note');
  const selectedList = document.getElementById('ap-selected-list');
  const selectedEmpty = document.getElementById('ap-selected-empty');

  /* Finitions */
  const fringeBubbles = document.getElementById('ap-fringe-bubbles');
  const symmetryBubbles = document.getElementById('ap-symmetry-bubbles');
  const edgeBubbles = document.getElementById('ap-edge-bubbles');

  /* Récap */
  const recapBox = document.getElementById('ap-recap');
  const totalVal = document.getElementById('ap-total-val');
  const lengthInput = document.getElementById('ap-length');
  const widthInput = document.getElementById('ap-width');

  const mode = root.getAttribute('data-mode') || 'page';
  const allPanels = Array.from(form.querySelectorAll('[data-ap-panel]'));
  const panelMap = {};
  allPanels.forEach(p => { panelMap[String(p.dataset.apPanel)] = p; });

  /* URL nuancier */
  const NUANCIER_URL = root.getAttribute('data-nuancier-url') || "";

  /* =============== OUTILS =============== */
  const normalize = s => (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const fmtEur = n => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n);
  function roundTo9(mode, value) {
    if (mode === 'AUCUN') return Math.round(value);
    const x = Math.round(value);
    if (mode === 'NEUF_SUP') return 10 * Math.ceil((x - 9) / 10) + 9;
    return 10 * Math.round((x - 9) / 10) + 9; // NEUF_PLUS_PROCHE
  }
  function pageSize() {
    const w = window.innerWidth;
    return w <= 560 ? PAGE_SIZE_MOBILE : w <= 920 ? PAGE_SIZE_TABLET : PAGE_SIZE_DESKTOP;
  }

  /* =============== STEPPER =============== */
  const STEP_CONFIG = {
    page: [
      { id: 'objet', panels: ['1'], short: 'Objet', full: 'Objet — Que souhaitez-vous créer ?' },
      { id: 'matiere', panels: ['2'], short: 'Matière', full: 'Matière — Choisissez votre matière' },
      { id: 'dimensions', panels: ['3'], short: 'Dimensions', full: 'Dimensions' },
      { id: 'nuancier', panels: ['4'], short: 'Nuancier', full: 'Nuancier & sélection' },
      { id: 'croquis', panels: ['5'], short: 'Croquis', full: 'Design — Croquis & références' },
      { id: 'finitions', panels: ['6'], short: 'Finitions', full: 'Franges & Bordures (options)' },
      { id: 'logistique', panels: ['7'], short: 'Logistique', full: 'Logistique — Adresse & contact' },
      { id: 'estimation', panels: ['8'], short: 'Estimation', full: 'Récapitulatif & estimation', computeQuote: true },
      { id: 'contact', panels: ['9'], short: 'Contact', full: 'Coordonnées & consentements', requiresEmail: true }
    ],
    product: [
      { id: 'objet', panels: ['1'], short: 'Objet', full: 'Objet' },
      { id: 'matiere', panels: ['2'], short: 'Matière', full: 'Matière' },
      { id: 'dimensions', panels: ['3'], short: 'Dimensions', full: 'Dimensions' },
      { id: 'couleurs', panels: ['4'], short: 'Couleurs', full: 'Couleurs' },
      { id: 'croquis', panels: ['5'], short: 'Croquis', full: 'Croquis & références' },
      { id: 'finitions', panels: ['6'], short: 'Finitions', full: 'Finitions' },
      { id: 'logistique', panels: ['7', '8'], short: 'Logistique', full: 'Logistique & estimation', computeQuote: true }
    ]
  };

  const stepConfig = STEP_CONFIG[mode] || STEP_CONFIG.page;
  const totalSteps = stepConfig.length;
  const activePanelIds = new Set(stepConfig.flatMap(cfg => cfg.panels));

  if (mode === 'product') {
    root.querySelectorAll('legend[data-ap-legend-default]').forEach(leg => {
      const txt = leg.getAttribute('data-ap-legend-default');
      if (txt) leg.textContent = txt;
    });
    root.querySelectorAll('legend[data-ap-legend-swap]').forEach(leg => {
      const txt = leg.getAttribute('data-ap-legend-swap');
      if (txt) leg.textContent = txt;
    });
  }

  allPanels.forEach(p => {
    if (!activePanelIds.has(String(p.dataset.apPanel))) {
      p.classList.add('ap-hidden');
    }
  });

  stepConfig.forEach((cfg, idx) => {
    const pill = document.createElement('div');
    pill.className = 'ap-pill';
    pill.dataset.step = String(idx + 1);
    pill.innerHTML = '<span class="dot"></span><span class="label">' + cfg.short + '</span>';
    pill.addEventListener('click', () => setStep(idx + 1, { fromClick: true }));
    stepper.appendChild(pill);
  });

  let step = 1;
  function animHeader() {
    stepIndexEl.classList.remove('ap-anim'); stepTitleEl.classList.remove('ap-anim');
    void stepTitleEl.offsetWidth;
    stepIndexEl.classList.add('ap-anim'); stepTitleEl.classList.add('ap-anim');
  }
  function scrollToTopOfForm() {
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function scrollActivePanel(current) {
    if (!current) return;
    const firstPanel = current.panels
      .map(pid => panelMap[pid])
      .find(Boolean);
    if (!firstPanel) return;

    const header = root.querySelector('.ap-top');
    const headerHeight = header ? header.offsetHeight : 0;
    const docTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const panelTop = firstPanel.getBoundingClientRect().top + docTop;
    const rootTop = root.getBoundingClientRect().top + docTop;
    const margin = 16;
    const targetTop = Math.max(rootTop - margin, panelTop - headerHeight - margin);

    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }
  function shouldCenterPill() {
    if (!root) return false;
    const mode = root.dataset.mode || 'page';
    const w = window.innerWidth;
    if (mode === 'page') return w <= 640;
    if (mode === 'product') return w <= 1024;
    return false;
  }
  function centerActivePill() {
    if (!shouldCenterPill()) return;
    const wrap = root.querySelector('.ap-stepper-wrap');
    const active = stepper?.querySelector('.ap-pill.active');
    if (!wrap || !active) return;
    const wrapRect = wrap.getBoundingClientRect();
    const pillRect = active.getBoundingClientRect();
    const offset = (pillRect.left + pillRect.width / 2) - (wrapRect.left + wrapRect.width / 2);
    wrap.scrollTo({
      left: wrap.scrollLeft + offset,
      behavior: 'smooth'
    });
  }
  function setStep(n, opts) {
    const options = (typeof opts === 'object' && opts !== null)
      ? opts
      : { fromClick: !!opts };
    const { skipScroll = false } = options;
    step = Math.max(1, Math.min(n, totalSteps));
    const current = stepConfig[step - 1];
    allPanels.forEach(p => p.classList.add('ap-hidden'));
    current.panels.forEach(pid => {
      const panel = panelMap[pid];
      if (panel) panel.classList.remove('ap-hidden');
    });

    const pills = [...stepper.querySelectorAll('.ap-pill')];
    pills.forEach((el, i) => { el.classList.toggle('active', i + 1 === step); el.classList.toggle('done', i + 1 < step); });

    stepIndexEl.textContent = 'Étape ' + step + '/' + totalSteps;
    stepTitleEl.textContent = current.full;
    animHeader();

    if (nextHintEl) {
      nextHintEl.textContent = step < totalSteps ? ('Étape suivante : ' + stepConfig[step].short) : '';
      nextHintEl.classList.toggle('ap-hidden', step === totalSteps);
    }

    if (prevBtn) prevBtn.disabled = (step === 1);

    if (mode === 'product') {
      if (nextBtn) {
        nextBtn.textContent = 'Continuer';
        nextBtn.classList.toggle('ap-hidden', step === totalSteps);
      }
      if (submitBtn) submitBtn.classList.add('ap-hidden');
      if (msg) {
        if (step === totalSteps) {
          msg.innerHTML = '<p class="ap-info">Pour finaliser votre projet, utilisez les boutons "Ajouter au panier" ou "Acheter maintenant" du bloc produit juste en dessous.</p>';
        } else {
          msg.textContent = '';
        }
      }
    } else {
      if (nextBtn) nextBtn.classList.toggle('ap-hidden', step === totalSteps);
      if (submitBtn) submitBtn.classList.toggle('ap-hidden', step !== totalSteps);
    }

    // reset/close info panels on step change
    document.querySelectorAll('.ap-info-panel').forEach(p => p.hidden = true);
    document.querySelectorAll('.ap-info-btn').forEach(b => b.setAttribute('aria-expanded', 'false'));

    if (current.id === 'finitions') renderFinitionsPreview();
    if (current.computeQuote) computeAndRenderQuote();
    centerActivePill();
    if (!skipScroll) scrollActivePanel(current);
  }

  /* =============== NAVIGATION / SUBMIT =============== */
  prevBtn.addEventListener('click', () => setStep(step - 1));
  nextBtn.addEventListener('click', () => {
    if (!validateCurrent()) return;
    if (step < totalSteps) {
      save();
      setStep(step + 1);
    }
  });
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!validateCurrent(true)) return;
    save();
    const tmpId = 'REQ-' + Math.random().toString(36).slice(2, 8).toUpperCase();
    localStorage.setItem('atelier_des_possibles_v1_tmp', tmpId);
    msg.innerHTML = `<p class="ap-success">Merci ! Votre demande ${tmpId} est enregistrée. Réservez maintenant votre rendez-vous.</p>`;

    const formDataSnapshot = new FormData(form);
    const payload = buildAtelierPayload(formDataSnapshot, { tmpId });
    // Envoi de la configuration complète de l’Atelier vers n8n (Webhook Maison Berbère).
    sendAtelierDataToN8N(payload);

    // Envoi vers Google Sheets pour collecte des données
    sendToGoogleSheets(formDataSnapshot, payload);

    const iframe = document.getElementById('gcal-embed');
    if (iframe) iframe.src = GOOGLE_APPT_URL;
    if (agenda) agenda.classList.remove('ap-hidden');
    scrollToTopOfForm();
  });

  /* =============== VALIDATION / SAVE =============== */
  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(val || '').trim());
  }

  function validateCurrent(isSubmit = false) {
    msg.textContent = '';
    let valid = true;
    const current = stepConfig[step - 1];
    const containers = current ? current.panels.map(pid => panelMap[pid]).filter(Boolean) : [];

    containers.forEach(container => {
      container.querySelectorAll('[required]').forEach(el => {
        if (el.type === 'radio' || el.type === 'checkbox') {
          const any = [...form.querySelectorAll(`[name="${el.name}"]`)].some(i => i.checked);
          if (!any) valid = false;
        } else if (!el.value) valid = false;
      });
    });

    if ((current?.requiresEmail || isSubmit) && current?.panels.includes('9')) {
      const email = form.elements['email']?.value || '';
      if (!isValidEmail(email)) {
        valid = false;
        msg.innerHTML = '<p class="ap-error">Veuillez entrer une boîte mail valide.</p>';
      }
    }

    if (!valid && !msg.innerHTML) {
      msg.innerHTML = '<p class="ap-error">Veuillez compléter les champs requis.</p>';
    }
    return valid;
  }

  function save() {
    const fd = new FormData(form); const o = {};
    fd.forEach((v, k) => {
      if (o[k]) { if (Array.isArray(o[k])) o[k].push(v); else o[k] = [o[k], v]; }
      else o[k] = v;
    });
    localStorage.setItem('atelier_des_possibles_v1', JSON.stringify(o));
  }

  /* =============== INFO PANELS =============== */
  function setupInfoToggles(scope) {
    scope.querySelectorAll('.ap-info-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('aria-controls');
        const panel = scope.querySelector('#' + id);
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        scope.querySelectorAll('.ap-info-panel').forEach(p => {
          if (p.id !== id) {
            p.hidden = true;
            const b = scope.querySelector(`.ap-info-btn[aria-controls="${p.id}"]`);
            b && b.setAttribute('aria-expanded', 'false');
          }
        });
        panel.hidden = expanded;
        btn.setAttribute('aria-expanded', String(!expanded));
      });
    });
  }
  function morphInfoButtonsToI() {
    document.querySelectorAll('.ap-info-btn').forEach(b => {
      b.textContent = 'i';
      b.setAttribute('aria-label', 'Informations');
      b.title = 'Informations';
    });
  }

  /* =============== FINITIONS (BULLES + APERÇUS) =============== */
  function bubbleSelect(container, groupName) {
    if (!container) return;
    const bubbles = Array.from(container.querySelectorAll('.ap-bubble'));
    bubbles.forEach(lbl => {
      const input = lbl.querySelector('input[type=radio]');
      if (!input) return;
      const mark = () => {
        bubbles.forEach(l => l.classList.toggle('selected', l === lbl));
      };
      input.addEventListener('change', () => {
        if (!input.checked) return;
        mark();
        computeAndRenderQuote();
        renderFinitionsPreview();
      });
      if (input.checked) {
        mark();
      }
    });
  }

  // NOUVELLE fonction de rendu pour les images alignées avec les sections
  function renderFinitionsPreview() {
    // Définir les trois conteneurs de prévisualisation
    const previews = [
      {
        container: document.getElementById('ap-preview-fringes'),
        bubbleContainer: fringeBubbles
      },
      {
        container: document.getElementById('ap-preview-edge'),
        bubbleContainer: edgeBubbles
      },
      {
        container: document.getElementById('ap-preview-symmetry'),
        bubbleContainer: symmetryBubbles
      }
    ];

    previews.forEach(preview => {
      if (!preview.container || !preview.bubbleContainer) return;

      // Vider le conteneur
      preview.container.innerHTML = '';

      // Récupérer l'input sélectionné
      const input = preview.bubbleContainer.querySelector('input[type=radio]:checked');
      if (!input) return;

      const bubble = input.closest('.ap-bubble');
      const imgSrc = bubble?.getAttribute('data-img');
      if (!imgSrc) return;

      // Créer l'image SANS titre
      const img = document.createElement('img');
      img.src = imgSrc;
      img.alt = FINITION_TITLES[input.value] || input.value;

      preview.container.appendChild(img);
    });
  }

  function applyOptionPrices() {
    document.querySelectorAll('[data-price-for]').forEach(el => {
      const val = el.getAttribute('data-price-for'); if (!val) return;
      const [group, key] = val.split(':');
      const map = PRICING.finishes[group];
      const price = map ? (map[key] || 0) : 0;
      el.textContent = price > 0 ? ('+' + new Intl.NumberFormat('fr-FR').format(price) + ' €') : 'Inclus';
    });
  }

  /* =============== CROQUIS : boutons “premium” + nom affiché =============== */
  function wireFileInputs() {
    document.querySelectorAll('.ap-file').forEach(wrap => {
      const input = wrap.querySelector('.ap-file-input');
      const nameEl = wrap.querySelector('.ap-file-name');
      if (!input || !nameEl) return;
      input.addEventListener('change', () => {
        const files = input.files ? Array.from(input.files) : [];
        if (!files.length) {
          nameEl.textContent = '';
          nameEl.removeAttribute('title');
          return;
        }
        const label = files.map(f => f.name).join(', ');
        nameEl.textContent = label;
        nameEl.title = label;
      });
    });
  }

  /* =============== NUANCIER (COMPLET EN FALLBACK) =============== */
  let ALL_COLORS = []; let FILTERED = []; let selectedColors = []; let page = 1;

  function familyOrder(fam) {
    const order = ['Bleus', 'Verts', 'Oranges', 'Jaunes', 'Rouges', 'Violets', 'Roses', 'Neutres', 'Bruns'];
    const i = order.indexOf(fam || ''); return i === -1 ? 99 : i;
  }
  function sortColors(list) {
    return list.slice().sort((a, b) => {
      const fa = familyOrder(a.family), fb = familyOrder(b.family);
      if (fa !== fb) return fa - fb;
      return (a.code || '').localeCompare(b.code || '');
    });
  }
  function familiesFromData(list) {
    const set = new Set(); list.forEach(c => { if (c.family) set.add(c.family); });
    return Array.from(set);
  }
  function renderFamilyFilter() {
    const fams = familiesFromData(ALL_COLORS);
    familyFilter.innerHTML = '<option value="">Toutes les familles</option>' + fams.map(f => `<option value="${f}">${f}</option>`).join('');
  }
  function getColorByCode(code) { return ALL_COLORS.find(x => x.code === code) || { code, name: '', hex: '#ccc' }; }

  function renderSelectedList() {
    selectedList.innerHTML = '';
    if (!selectedColors.length) {
      selectedEmpty.style.display = 'block';
      return;
    }
    selectedEmpty.style.display = 'none';
    selectedColors.forEach(code => {
      const c = getColorByCode(code);
      const li = document.createElement('li'); li.className = 'ap-chipSel';
      li.innerHTML = `
        <span class="ap-dot" style="background:${c.hex || '#ccc'}"></span>
        <span class="nm">${c.name || ''}</span><span class="cd">${c.code || ''}</span>
        <span class="x" aria-label="Retirer" title="Retirer">×</span>
      `;
      li.querySelector('.x').addEventListener('click', () => toggleByCode(code));
      selectedList.appendChild(li);
    });
  }
  function updateSelected() {
    paletteHidden.value = selectedColors.join(', ');
    const countNote = document.getElementById('ap-count-note');
    if (countNote) countNote.textContent = `${selectedColors.length} sélection / ${MAX_COLORS}`;
    renderSelectedList();
    computeAndRenderQuote();
  }
  function toggleByCode(code) {
    const i = selectedColors.indexOf(code);
    if (i === -1) {
      if (selectedColors.length >= MAX_COLORS) {
        msg.innerHTML = '<p class="ap-error">Maximum 5 couleurs.</p>'; return;
      }
      selectedColors.push(code);
    } else {
      selectedColors.splice(i, 1);
    }
    updateSelected();
    const card = swatchGrid.querySelector(`.ap-swatch[data-code="${CSS.escape(code)}"]`);
    if (card) {
      card.classList.toggle('selected', selectedColors.includes(code));
      const input = card.querySelector('input[type=checkbox]');
      if (input) input.checked = selectedColors.includes(code);
    }
  }

  function buildAtelierPayload(formData, context = {}) {
    const plain = formDataToObject(formData);
    const toNumberOrNull = (val) => {
      if (val === null || val === undefined || val === '') return null;
      const n = Number(val);
      return Number.isFinite(n) ? n : null;
    };

    const lengthCm = toNumberOrNull(formData.get('length_cm'));
    const widthCm = toNumberOrNull(formData.get('width_cm'));
    const line = formData.get('weave_line') || null;
    const area = (lengthCm && widthCm) ? Math.max(0, (lengthCm * widthCm) / 10000) : 0;
    const rate = line ? (PRICING.rate_m2[line] || 0) : 0;
    const hasDims = !!(lengthCm && widthCm);

    const fringeChoice = formData.get('fringes') || 'classiques';
    const edgeChoice = formData.get('edge') || 'surjet';
    const symmetryChoice = formData.get('symmetry') || 'asym';

    const addFrHT = PRICING.finishes.fringes?.[fringeChoice] || 0;
    const addEdHT = PRICING.finishes.edge?.[edgeChoice] || 0;
    const addSymHT = PRICING.finishes.symmetry?.[symmetryChoice] || 0;
    const optsHT = addFrHT + addEdHT + addSymHT;

    const designHT = (PRICING.INCLURE_FORFAIT_DESIGN && hasDims) ? PRICING.FORFAIT_DESIGN : 0;
    const shipHT = PRICING.FRAIS_TRANSPORT_INCLUS || 0;
    const baseHT = area * rate;
    const totalHT = Math.max(0, baseHT + optsHT + designHT + shipHT);
    const totalTTC = totalHT * (1 + PRICING.TVA);
    const totalAff = roundTo9(PRICING.ARRONDI_TTC, totalTTC);
    const tvaAmount = totalHT * PRICING.TVA;

    const paletteCodesRaw = (selectedColors.length
      ? Array.from(selectedColors)
      : (formData.get('palette_codes') || '')
        .split(',')
        .map(code => code.trim())
        .filter(Boolean)
    );

    const palette = paletteCodesRaw.map(code => {
      const color = getColorByCode(code);
      return {
        role: null,
        nom: color.name || null,
        code_nuancier: color.code || code || null,
        hex: color.hex || null
      };
    });

    const storyNotes = (formData.get('story_notes') || '').trim() || null;
    const fullName = (formData.get('name') || '').trim();
    let prenom = null;
    let nom = null;
    if (fullName) {
      const parts = fullName.split(/\s+/);
      prenom = parts.shift() || null;
      nom = parts.length ? parts.join(' ') : null;
    }

    const phone = (formData.get('phone') || '').trim() || null;
    const email = (formData.get('email') || '').trim() || null;

    const street = (formData.get('street') || '').trim() || null;
    const city = (formData.get('city') || '').trim() || null;
    const zip = (formData.get('zip') || '').trim() || null;
    const country = (formData.get('country') || '').trim() || null;
    const access = (formData.get('access') || '').trim() || null;

    const fringeConfigMap = {
      classiques: { configuration: 'standard', style: 'franges_classiques', present: true },
      torsadees: { configuration: 'premium', style: 'franges_torsadees', present: true },
      bord_tisse: { configuration: 'aucune', style: 'bord_tisse', present: false }
    };
    const symmetryMap = {
      asym: 'asymetrique',
      sym: 'symetrique',
      modern: 'contemporain'
    };

    const paletteRemarks = null;
    const newsletterOptin = !!plain.newsletter_optin;

    const sketchInput = document.getElementById('ap-sketch');
    const refsInput = document.getElementById('ap-refs');
    const sketchFiles = sketchInput?.files ? Array.from(sketchInput.files).map(f => f.name) : [];
    const refsFiles = refsInput?.files ? Array.from(refsInput.files).map(f => f.name) : [];
    const hasUploads = sketchFiles.length > 0 || refsFiles.length > 0;

    const payload = {
      meta: {
        version: 'atelier-des-possibles-v1',
        submitted_at: new Date().toISOString(),
        page_url: window.location.href,
        source: 'atelier_des_possibles',
        mode,
        tmp_request_id: context.tmpId || null,
        selected_colors_count: palette.length,
        raw_form_snapshot: plain
      },
      client: {
        prenom,
        nom,
        nom_complet: fullName || null,
        email,
        telephone: phone,
        newsletter_optin: newsletterOptin
      },
      projet: {
        piece: null,
        style_deco: null,
        objectif: null,
        commentaire_global: storyNotes
      },
      tapis: {
        type_tapis: formData.get('object_type') || null,
        collection: null,
        matiere_principale: line,
        epaisseur_mm: null,
        hauteur_poil_mm: null,
        densite_approx: null,
        usage: null
      },
      dimensions: {
        forme: null,
        largeur_cm: widthCm,
        longueur_cm: lengthCm,
        diametre_cm: null,
        tolerance_coupe_cm: null,
        surface_calculee_m2: area || null
      },
      couleurs: {
        palette,
        remarques: paletteRemarks
      },
      finition: {
        franges: {
          present: fringeConfigMap[fringeChoice]?.present ?? null,
          configuration: fringeConfigMap[fringeChoice]?.configuration || null,
          style: fringeConfigMap[fringeChoice]?.style || null,
          longueur_cm: null
        },
        bordures: {
          type: edgeChoice,
          couleur: null
        },
        angles: {
          traitement: null
        },
        symmetry: symmetryChoice,
        symmetry_description: symmetryMap[symmetryChoice] || null
      },
      logistique: {
        pays: country,
        ville: city,
        code_postal: zip,
        adresse: street,
        complement_adresse: null,
        etage: null,
        ascenseur: null,
        contraintes_acces: access
      },
      estimation: {
        surface_m2: area || null,
        prix_m2_ht: rate || null,
        prix_tapis_ht: baseHT + optsHT || 0,
        frais_options_ht: optsHT || 0,
        frais_livraison_ht: shipHT || 0,
        frais_design_ht: designHT || 0,
        prix_total_ht: totalHT || 0,
        tva: tvaAmount || 0,
        prix_total_ttc: totalAff || 0,
        prix_total_ttc_theorique: totalTTC || 0,
        devise: 'EUR',
        delai_estime_semaines: null
      },
      croquis: {
        type: hasUploads ? 'upload_client' : 'pas_de_croquis',
        description: storyNotes,
        image_urls: [],
        fichiers_client: {
          croquis: sketchFiles,
          references: refsFiles
        }
      },
      consentements: {
        cgv_acceptees: formData.get('terms') !== null,
        rgpd_accepte: formData.get('terms') !== null,
        droits_fichiers_confirmes: formData.get('ip_rights') !== null,
        contact_telephone_autorise: null,
        contact_email_autorise: null
      }
    };

    return payload;
  }

  function renderSwatches() {
    const ps = pageSize();
    const totalPages = Math.max(1, Math.ceil(FILTERED.length / ps));
    if (page > totalPages) page = totalPages;
    const start = (page - 1) * ps;
    const visible = FILTERED.slice(start, start + ps);

    swatchGrid.innerHTML = '';
    visible.forEach((c, idx) => {
      const card = document.createElement('label');
      card.className = 'ap-swatch ap-anim';
      card.style.animationDelay = (idx * 12) + 'ms';
      card.dataset.code = c.code;

      const input = document.createElement('input');
      input.type = 'checkbox'; input.value = c.code;
      input.checked = selectedColors.includes(c.code);
      input.addEventListener('change', () => toggleByCode(c.code));

      const sample = document.createElement('span');
      sample.className = 'ap-sample';
      sample.style.backgroundColor = c.hex || '#ddd';
      if (c.photo) sample.style.backgroundImage = `url('${c.photo}')`;

      const meta = document.createElement('div');
      meta.className = 'ap-meta';
      meta.innerHTML = `
        <div class="ap-meta-left">
          <span class="name">${c.name || c.code}</span>
          <span class="code">${c.code || ''}</span>
        </div>
        <span class="ap-dot" style="background:${c.hex || '#ccc'}" title="${c.hex || ''}"></span>
      `;

      card.appendChild(input); card.appendChild(sample); card.appendChild(meta);
      if (selectedColors.includes(c.code)) card.classList.add('selected');
      swatchGrid.appendChild(card);
    });

    pagePrev.disabled = (page <= 1);
    pageNext.disabled = (page >= totalPages);
    pageNote.textContent = `Page ${page}/${totalPages}`;
  }

  function applyFilter() {
    const q = normalize(swatchSearch.value || '').trim();
    const fam = familyFilter.value;
    FILTERED = sortColors(ALL_COLORS.filter(c => {
      const matchF = !fam || c.family === fam;
      const basic = !q || normalize((c.code || '') + ' ' + (c.name || '')).includes(q);
      return matchF && basic;
    }));
    page = 1; renderSwatches();
  }

  pagePrev.addEventListener('click', () => { if (page > 1) { page--; renderSwatches(); } });
  pageNext.addEventListener('click', () => {
    const ps = pageSize(); const totalPages = Math.max(1, Math.ceil(FILTERED.length / ps));
    if (page < totalPages) { page++; renderSwatches(); }
  });
  window.addEventListener('resize', () => { renderSwatches(); renderAllFinishPreviews(); });
  swatchSearch.addEventListener('input', applyFilter);
  familyFilter.addEventListener('change', applyFilter);

  // ====== Fallback complet (liste RAL/MOC) ======
  const NUANCIER_EMBED = [
    /* ===== BLEUS ===== */
    { "code": "RAL 5000", "name": "Bleu violet", "hex": "#1F3438", "family": "Bleus" },
    { "code": "RAL 5002", "name": "Bleu outremer", "hex": "#2B3A77", "family": "Bleus" },
    { "code": "RAL 5003", "name": "Bleu saphir", "hex": "#1F3A5F", "family": "Bleus" },
    { "code": "RAL 5004", "name": "Bleu noir", "hex": "#18171C", "family": "Bleus" },
    { "code": "RAL 5005", "name": "Bleu signalisation", "hex": "#154889", "family": "Bleus" },
    { "code": "RAL 5007", "name": "Bleu brillant", "hex": "#37688A", "family": "Bleus" },
    { "code": "RAL 5008", "name": "Bleu gris", "hex": "#26252D", "family": "Bleus" },
    { "code": "RAL 5009", "name": "Bleu azur", "hex": "#2B5D7E", "family": "Bleus" },
    { "code": "RAL 5010", "name": "Bleu gentiane", "hex": "#0E294B", "family": "Bleus" },
    { "code": "RAL 5011", "name": "Bleu acier", "hex": "#1A2634", "family": "Bleus" },
    { "code": "RAL 5012", "name": "Bleu clair", "hex": "#45B5E3", "family": "Bleus" },
    { "code": "RAL 5013", "name": "Bleu cobalt", "hex": "#20214F", "family": "Bleus" },
    { "code": "RAL 5014", "name": "Bleu pigeon", "hex": "#606E8C", "family": "Bleus" },
    { "code": "RAL 5015", "name": "Bleu ciel", "hex": "#007DB8", "family": "Bleus" },
    { "code": "RAL 5017", "name": "Bleu signalisation vif", "hex": "#005B8F", "family": "Bleus" },
    { "code": "RAL 5018", "name": "Bleu turquoise", "hex": "#28A5B5", "family": "Bleus" },
    { "code": "RAL 5020", "name": "Bleu océan", "hex": "#0B4151", "family": "Bleus" },
    { "code": "RAL 5021", "name": "Bleu d’eau", "hex": "#07737A", "family": "Bleus" },
    { "code": "RAL 5022", "name": "Bleu nuit", "hex": "#20214F", "family": "Bleus" },
    { "code": "RAL 5023", "name": "Bleu distant", "hex": "#4D6D8C", "family": "Bleus" },
    { "code": "RAL 5024", "name": "Bleu pastel", "hex": "#7291B8", "family": "Bleus" },
    { "code": "RAL 5025", "name": "Bleu gentiane nacré", "hex": "#2A6F97", "family": "Bleus" },
    { "code": "RAL 5026", "name": "Bleu nuit nacré", "hex": "#2A2E3B", "family": "Bleus" },
    { "code": "MOC 5100", "name": "Bleu Roi", "hex": "#1C3F94", "family": "Bleus" },
    { "code": "MOC 5101", "name": "Bleu Profond", "hex": "#213A73", "family": "Bleus" },
    { "code": "MOC 5102", "name": "Bleu Indigo", "hex": "#263A7B", "family": "Bleus" },

    /* ===== VERTS ===== */
    { "code": "RAL 6000", "name": "Vert platane", "hex": "#327662", "family": "Verts" },
    { "code": "RAL 6001", "name": "Vert émeraude", "hex": "#28713E", "family": "Verts" },
    { "code": "RAL 6002", "name": "Vert feuillage", "hex": "#276235", "family": "Verts" },
    { "code": "RAL 6003", "name": "Vert olive", "hex": "#4B573E", "family": "Verts" },
    { "code": "RAL 6004", "name": "Vert bleu", "hex": "#0E6251", "family": "Verts" },
    { "code": "RAL 6005", "name": "Vert mousse", "hex": "#0A3C2F", "family": "Verts" },
    { "code": "RAL 6007", "name": "Vert bouteille", "hex": "#2C3222", "family": "Verts" },
    { "code": "RAL 6009", "name": "Vert sapin", "hex": "#1F3A3D", "family": "Verts" },
    { "code": "RAL 6010", "name": "Vert herbe", "hex": "#4C9141", "family": "Verts" },
    { "code": "RAL 6011", "name": "Vert réséda", "hex": "#67825D", "family": "Verts" },
    { "code": "RAL 6012", "name": "Vert noir", "hex": "#1F2926", "family": "Verts" },
    { "code": "RAL 6013", "name": "Vert jonc", "hex": "#6C7156", "family": "Verts" },
    { "code": "RAL 6016", "name": "Vert turquoise", "hex": "#00694B", "family": "Verts" },
    { "code": "RAL 6017", "name": "Vert mai", "hex": "#4C9141", "family": "Verts" },
    { "code": "RAL 6018", "name": "Vert jaune", "hex": "#4BAF4F", "family": "Verts" },
    { "code": "RAL 6019", "name": "Vert blanc", "hex": "#B7D9B1", "family": "Verts" },
    { "code": "RAL 6020", "name": "Vert oxyde de chrome", "hex": "#3B5742", "family": "Verts" },
    { "code": "RAL 6021", "name": "Vert pâle", "hex": "#89AC76", "family": "Verts" },
    { "code": "RAL 6024", "name": "Vert signalisation", "hex": "#00875A", "family": "Verts" },
    { "code": "RAL 6025", "name": "Vert fougère", "hex": "#3C7F59", "family": "Verts" },
    { "code": "RAL 6026", "name": "Vert opale", "hex": "#005F5B", "family": "Verts" },
    { "code": "RAL 6027", "name": "Vert clair", "hex": "#7FB5B5", "family": "Verts" },
    { "code": "RAL 6028", "name": "Vert pin", "hex": "#315442", "family": "Verts" },
    { "code": "RAL 6029", "name": "Vert menthe", "hex": "#007B4B", "family": "Verts" },
    { "code": "RAL 6032", "name": "Vert sécurité", "hex": "#0B7D3E", "family": "Verts" },
    { "code": "RAL 6033", "name": "Turquoise menthe", "hex": "#469C9B", "family": "Verts" },
    { "code": "RAL 6034", "name": "Turquoise pastel", "hex": "#7FB5B5", "family": "Verts" },
    { "code": "RAL 6037", "name": "Vert pur", "hex": "#25E712", "family": "Verts" },
    { "code": "RAL 6038", "name": "Vert fluorescent", "hex": "#0AFF0A", "family": "Verts" },
    { "code": "MOC 6100", "name": "Vert nacré", "hex": "#7AA882", "family": "Verts" },
    { "code": "MOC 6101", "name": "Vert pistache", "hex": "#A9D39E", "family": "Verts" },
    { "code": "MOC 6102", "name": "Vert turquoise clair", "hex": "#9FD8D2", "family": "Verts" },
    { "code": "MOC 6103", "name": "Vert atlas", "hex": "#5B8F6D", "family": "Verts" },

    /* ===== JAUNES ===== */
    { "code": "RAL 1000", "name": "Beige vert", "hex": "#BEBD7F", "family": "Jaunes" },
    { "code": "RAL 1001", "name": "Beige", "hex": "#C2B078", "family": "Jaunes" },
    { "code": "RAL 1002", "name": "Jaune sable", "hex": "#D6C89A", "family": "Jaunes" },
    { "code": "RAL 1003", "name": "Jaune signalisation", "hex": "#F4A900", "family": "Jaunes" },
    { "code": "RAL 1004", "name": "Jaune or", "hex": "#E2B007", "family": "Jaunes" },
    { "code": "RAL 1005", "name": "Jaune miel", "hex": "#C7A100", "family": "Jaunes" },
    { "code": "RAL 1006", "name": "Jaune maïs", "hex": "#E5BE01", "family": "Jaunes" },
    { "code": "RAL 1007", "name": "Jaune narcisse", "hex": "#DAA520", "family": "Jaunes" },
    { "code": "RAL 1012", "name": "Jaune citron", "hex": "#D9C022", "family": "Jaunes" },
    { "code": "RAL 1015", "name": "Ivoire clair", "hex": "#E6D2B5", "family": "Jaunes" },
    { "code": "RAL 1016", "name": "Jaune soufre", "hex": "#EAF044", "family": "Jaunes" },
    { "code": "RAL 1017", "name": "Jaune safran", "hex": "#F4B752", "family": "Jaunes" },
    { "code": "RAL 1018", "name": "Jaune zinc", "hex": "#F1DD38", "family": "Jaunes" },
    { "code": "RAL 1021", "name": "Jaune colza", "hex": "#F6B40E", "family": "Jaunes" },
    { "code": "RAL 1023", "name": "Jaune signalisation vif", "hex": "#F7B500", "family": "Jaunes" },
    { "code": "RAL 1024", "name": "Jaune ocre", "hex": "#B89C50", "family": "Jaunes" },
    { "code": "RAL 1027", "name": "Jaune curry", "hex": "#9A7611", "family": "Jaunes" },
    { "code": "RAL 1032", "name": "Jaune genêt", "hex": "#E6A32E", "family": "Jaunes" },
    { "code": "RAL 1033", "name": "Jaune dahlia", "hex": "#F99A1C", "family": "Jaunes" },
    { "code": "RAL 1034", "name": "Jaune pastel", "hex": "#EBA420", "family": "Jaunes" },
    { "code": "MOC 1102", "name": "Jaune Meski", "hex": "#F0C35B", "family": "Jaunes" },

    /* ===== ORANGES ===== */
    { "code": "RAL 2000", "name": "Orange jaune", "hex": "#ED7F00", "family": "Oranges" },
    { "code": "RAL 2001", "name": "Orangé rouge", "hex": "#A9461B", "family": "Oranges" },
    { "code": "RAL 2002", "name": "Orangé sang", "hex": "#CB472B", "family": "Oranges" },
    { "code": "RAL 2003", "name": "Orangé pastel", "hex": "#F99922", "family": "Oranges" },
    { "code": "RAL 2004", "name": "Orangé pur", "hex": "#F44611", "family": "Oranges" },
    { "code": "RAL 2005", "name": "Orangé brillant", "hex": "#FF4D00", "family": "Oranges" },
    { "code": "RAL 2008", "name": "Orange rouge claire", "hex": "#F3752C", "family": "Oranges" },
    { "code": "RAL 2009", "name": "Orange trafic", "hex": "#F54021", "family": "Oranges" },
    { "code": "RAL 2010", "name": "Orange signalisation", "hex": "#D84B20", "family": "Oranges" },
    { "code": "RAL 2011", "name": "Orange profond", "hex": "#EC7C26", "family": "Oranges" },
    { "code": "RAL 2012", "name": "Orange saumon", "hex": "#DB6A50", "family": "Oranges" },
    { "code": "MOC 2102", "name": "Saumon clair", "hex": "#F3C0A6", "family": "Oranges" },
    { "code": "MOC 2103", "name": "Saumon moyen", "hex": "#E89D7C", "family": "Oranges" },
    { "code": "MOC 2105", "name": "Orange brique", "hex": "#D26E3A", "family": "Oranges" },

    /* ===== ROUGES ===== */
    { "code": "RAL 3000", "name": "Rouge feu", "hex": "#AF2B1E", "family": "Rouges" },
    { "code": "RAL 3001", "name": "Rouge signalisation", "hex": "#A52019", "family": "Rouges" },
    { "code": "RAL 3002", "name": "Rouge carmin", "hex": "#A02128", "family": "Rouges" },
    { "code": "RAL 3003", "name": "Rouge rubis", "hex": "#8A1C1C", "family": "Rouges" },
    { "code": "RAL 3004", "name": "Rouge pourpre", "hex": "#701F29", "family": "Rouges" },
    { "code": "RAL 3005", "name": "Rouge vin", "hex": "#5D191A", "family": "Rouges" },
    { "code": "RAL 3007", "name": "Rouge noir", "hex": "#2E1A1A", "family": "Rouges" },
    { "code": "RAL 3009", "name": "Rouge oxyde", "hex": "#6D312B", "family": "Rouges" },
    { "code": "RAL 3011", "name": "Rouge brun", "hex": "#783F3E", "family": "Rouges" },
    { "code": "RAL 3012", "name": "Rouge beige", "hex": "#C3876D", "family": "Rouges" },
    { "code": "RAL 3013", "name": "Rouge tomate", "hex": "#B03F3C", "family": "Rouges" },
    { "code": "RAL 3016", "name": "Rouge corail", "hex": "#A23B2A", "family": "Rouges" },
    { "code": "RAL 3017", "name": "Rosé", "hex": "#D3545F", "family": "Roses" },
    { "code": "RAL 3018", "name": "Rouge fraise", "hex": "#C73F4A", "family": "Rouges" },
    { "code": "RAL 3020", "name": "Rouge vif signalisation", "hex": "#C41E3A", "family": "Rouges" },
    { "code": "RAL 3022", "name": "Rouge saumon", "hex": "#D95030", "family": "Rouges" },
    { "code": "RAL 3027", "name": "Rouge framboise", "hex": "#B42041", "family": "Rouges" },
    { "code": "RAL 3028", "name": "Rouge pur", "hex": "#F70000", "family": "Rouges" },
    { "code": "RAL 3031", "name": "Rouge orient", "hex": "#AC3B3A", "family": "Rouges" },

    /* ===== VIOLETS ===== */
    { "code": "RAL 4001", "name": "Lilas rouge", "hex": "#6D3F5B", "family": "Violets" },
    { "code": "RAL 4002", "name": "Violet rouge", "hex": "#922B3E", "family": "Violets" },
    { "code": "RAL 4003", "name": "Violet bruyère", "hex": "#C461A0", "family": "Violets" },
    { "code": "RAL 4004", "name": "Violet bordeaux", "hex": "#641C34", "family": "Violets" },
    { "code": "RAL 4005", "name": "Violet bleu", "hex": "#6C4675", "family": "Violets" },
    { "code": "RAL 4006", "name": "Pourpre signalisation", "hex": "#901E5A", "family": "Violets" },
    { "code": "RAL 4007", "name": "Violet pourpre", "hex": "#4A192C", "family": "Violets" },
    { "code": "RAL 4008", "name": "Violet signalisation", "hex": "#904684", "family": "Violets" },
    { "code": "RAL 4009", "name": "Violet pastel", "hex": "#A38995", "family": "Violets" },
    { "code": "RAL 4010", "name": "Télé magenta", "hex": "#CF3476", "family": "Violets" },

    /* ===== ROSES (sélection) ===== */
    { "code": "RAL 3014", "name": "Vieux rose", "hex": "#D8A0A6", "family": "Roses" },
    { "code": "RAL 3015", "name": "Rose clair", "hex": "#E1A6AD", "family": "Roses" },
    { "code": "RAL 3017", "name": "Rosé", "hex": "#D3545F", "family": "Roses" },
    { "code": "RAL 3018", "name": "Rouge fraise", "hex": "#C73F4A", "family": "Roses" },

    /* ===== NEUTRES ===== */
    { "code": "RAL 7000", "name": "Gris petit-gris", "hex": "#78858B", "family": "Neutres" },
    { "code": "RAL 7001", "name": "Gris argent", "hex": "#8A9597", "family": "Neutres" },
    { "code": "RAL 7002", "name": "Gris olive", "hex": "#817F68", "family": "Neutres" },
    { "code": "RAL 7003", "name": "Gris mousse", "hex": "#7A7B6D", "family": "Neutres" },
    { "code": "RAL 7004", "name": "Gris signalisation", "hex": "#969992", "family": "Neutres" },
    { "code": "RAL 7005", "name": "Gris souris", "hex": "#6B716F", "family": "Neutres" },
    { "code": "RAL 7006", "name": "Gris beige", "hex": "#756F61", "family": "Neutres" },
    { "code": "RAL 7008", "name": "Gris kaki", "hex": "#75623C", "family": "Neutres" },
    { "code": "RAL 7010", "name": "Gris tente", "hex": "#575D57", "family": "Neutres" },
    { "code": "RAL 7011", "name": "Gris fer", "hex": "#555D61", "family": "Neutres" },
    { "code": "RAL 7012", "name": "Gris basalte", "hex": "#596163", "family": "Neutres" },
    { "code": "RAL 7013", "name": "Brun gris", "hex": "#555548", "family": "Neutres" },
    { "code": "RAL 7015", "name": "Gris ardoise", "hex": "#51565C", "family": "Neutres" },
    { "code": "RAL 7016", "name": "Gris anthracite", "hex": "#373F43", "family": "Neutres" },
    { "code": "RAL 7021", "name": "Gris noir", "hex": "#2F353B", "family": "Neutres" },
    { "code": "RAL 7022", "name": "Gris ombre", "hex": "#4B4D46", "family": "Neutres" },
    { "code": "RAL 7023", "name": "Gris béton", "hex": "#818479", "family": "Neutres" },
    { "code": "RAL 7024", "name": "Gris graphite", "hex": "#474A50", "family": "Neutres" },
    { "code": "RAL 7030", "name": "Gris pierre", "hex": "#939388", "family": "Neutres" },
    { "code": "RAL 7032", "name": "Gris silex", "hex": "#B9B9A8", "family": "Neutres" },
    { "code": "RAL 7035", "name": "Gris clair", "hex": "#D7D7D7", "family": "Neutres" },
    { "code": "RAL 7037", "name": "Gris poussière", "hex": "#7C7F7E", "family": "Neutres" },
    { "code": "RAL 7038", "name": "Gris agate", "hex": "#B5B8B1", "family": "Neutres" },
    { "code": "RAL 7040", "name": "Gris fenêtre", "hex": "#9DA3A6", "family": "Neutres" },
    { "code": "RAL 7042", "name": "Gris signalisation A", "hex": "#8D9591", "family": "Neutres" },
    { "code": "RAL 7043", "name": "Gris signalisation B", "hex": "#4E5451", "family": "Neutres" },
    { "code": "RAL 7046", "name": "Télégris 2", "hex": "#8D9196", "family": "Neutres" },
    { "code": "RAL 7047", "name": "Télégris 4", "hex": "#D0D0D0", "family": "Neutres" },
    { "code": "RAL 7048", "name": "Gris souris nacré", "hex": "#888D8F", "family": "Neutres" },
    { "code": "RAL 9002", "name": "Blanc gris", "hex": "#E7EBDA", "family": "Neutres" },
    { "code": "RAL 9003", "name": "Blanc signalisation", "hex": "#F4F4F4", "family": "Neutres" },
    { "code": "RAL 9005", "name": "Noir foncé", "hex": "#0A0A0A", "family": "Neutres" },
    { "code": "RAL 9006", "name": "Aluminium blanc", "hex": "#A5A5A5", "family": "Neutres" },
    { "code": "RAL 9007", "name": "Aluminium gris", "hex": "#8F8F8F", "family": "Neutres" },
    { "code": "RAL 9010", "name": "Blanc pur", "hex": "#F4F4F4", "family": "Neutres" },
    { "code": "RAL 9016", "name": "Blanc signalisation", "hex": "#FFFFFF", "family": "Neutres" },
    { "code": "RAL 9017", "name": "Noir trafic", "hex": "#1E1E1E", "family": "Neutres" },
    { "code": "RAL 9018", "name": "Blanc papier", "hex": "#D8DFE2", "family": "Neutres" },
    { "code": "MOC 9100", "name": "Écru marocaine", "hex": "#E6DECF", "family": "Neutres" },
    { "code": "MOC 9101", "name": "Blanc CV", "hex": "#F2EDE4", "family": "Neutres" },

    /* ===== BRUNS ===== */
    { "code": "RAL 8000", "name": "Brun verdâtre", "hex": "#7E6A43", "family": "Bruns" },
    { "code": "RAL 8001", "name": "Brun terre de sienne", "hex": "#9A622A", "family": "Bruns" },
    { "code": "RAL 8002", "name": "Brun de sécurité", "hex": "#7B5141", "family": "Bruns" },
    { "code": "RAL 8003", "name": "Brun argile", "hex": "#855C33", "family": "Bruns" },
    { "code": "RAL 8004", "name": "Brun cuivre", "hex": "#8E5A3C", "family": "Bruns" },
    { "code": "RAL 8007", "name": "Brun fauve", "hex": "#6F4A2F", "family": "Bruns" },
    { "code": "RAL 8008", "name": "Brun olive", "hex": "#6F4F28", "family": "Bruns" },
    { "code": "RAL 8011", "name": "Brun noisette", "hex": "#5B3A29", "family": "Bruns" },
    { "code": "RAL 8014", "name": "Brun sépia", "hex": "#49392D", "family": "Bruns" },
    { "code": "RAL 8015", "name": "Brun marron", "hex": "#633A34", "family": "Bruns" },
    { "code": "RAL 8016", "name": "Brun acajou", "hex": "#4C2F26", "family": "Bruns" },
    { "code": "RAL 8017", "name": "Brun chocolat", "hex": "#45322E", "family": "Bruns" },
    { "code": "RAL 8019", "name": "Brun gris", "hex": "#3B3C36", "family": "Bruns" },
    { "code": "RAL 8022", "name": "Brun noir", "hex": "#1A1718", "family": "Bruns" },
    { "code": "RAL 8023", "name": "Brun orangé", "hex": "#A65E2E", "family": "Bruns" },
    { "code": "RAL 8024", "name": "Marron clair", "hex": "#79553C", "family": "Bruns" },
    { "code": "RAL 8025", "name": "Brun pâle", "hex": "#755F4B", "family": "Bruns" },
    { "code": "RAL 8028", "name": "Brun terre", "hex": "#4E3B31", "family": "Bruns" },
    { "code": "RAL 8029", "name": "Cuivre nacré", "hex": "#774C3B", "family": "Bruns" },
    { "code": "MOC 8100", "name": "Tabac", "hex": "#6E4E3B", "family": "Bruns" },
    { "code": "MOC 8101", "name": "Brun beige", "hex": "#8A6A52", "family": "Bruns" },
    { "code": "MOC 8102", "name": "Brun caramel", "hex": "#A45E3A", "family": "Bruns" }
  ];

  async function loadNuancier() {
    // 1) Fallback embarqué = toutes les couleurs
    ALL_COLORS = sortColors(NUANCIER_EMBED.slice());
    FILTERED = ALL_COLORS.slice();
    renderFamilyFilter();
    renderSwatches();
    updateSelected();

    // 2) Essayer le JSON distant (si accessible) pour écraser le fallback
    if (!NUANCIER_URL) return;
    try {
      const res = await fetch(NUANCIER_URL, { cache: 'no-store', mode: 'cors', credentials: 'omit' });
      if (res.ok) {
        const raw = await res.text();
        const clean = raw
          .replace(/\/\*[\s\S]*?\*\//g, '')
          .replace(/(^|\s)\/\/[^\n\r]*/g, '$1');
        const data = JSON.parse(clean);
        if (Array.isArray(data) && data.length) {
          ALL_COLORS = sortColors(data.map(c => ({
            code: String(c.code || '').trim(),
            name: c.name || '',
            hex: c.hex || '',
            family: c.family || '',
            photo: c.photo || ''
          })).filter(c => !!c.code));
          FILTERED = ALL_COLORS.slice();
          renderFamilyFilter();
          renderSwatches();
          updateSelected();
        }
      }
    } catch (e) {
      console.warn('Nuancier distant indisponible ou invalide. Fallback embarqué conservé.', e);
    }
  }

  /* =============== ESTIMATION / RÉCAP =============== */
  function computeAndRenderQuote() {
    if (!recapBox || !totalVal || !form) return;

    if (mode === 'product') {
      const L = Number(lengthInput?.value || 0);
      const W = Number(widthInput?.value || 0);
      const area = Math.max(0, (L * W) / 10000);

      const lineInput = form.querySelector('input[name="weave_line"]:checked');
      const line = lineInput ? lineInput.value : null;
      const hasConfig = !!line && L > 0 && W > 0;

      if (!hasConfig) {
        recapBox.innerHTML = `
          <div class="ap-line">
            <div class="k">Estimation</div>
            <div>Complétez la matière et les dimensions pour voir le montant estimatif.</div>
          </div>
        `;
        totalVal.textContent = '—';
        return;
      }

      const rate = line ? (PRICING.rate_m2[line] || 0) : 0;
      const baseHT = area * rate;

      const fringe = (form.querySelector('input[name="fringes"]:checked') || {}).value || 'classiques';
      const edge = (form.querySelector('input[name="edge"]:checked') || {}).value || 'surjet';
      const sym = (form.querySelector('input[name="symmetry"]:checked') || {}).value || 'sym';

      const addFrHT = PRICING.finishes.fringes[fringe] || 0;
      const addEdHT = PRICING.finishes.edge[edge] || 0;
      const addSymHT = PRICING.finishes.symmetry[sym] || 0;
      const optsHT = addFrHT + addEdHT + addSymHT;

      const designHT = hasConfig ? PRICING.FORFAIT_DESIGN : 0;
      const totalHT = baseHT + optsHT + designHT;
      const totalTTC = totalHT * (1 + PRICING.TVA);

      recapBox.innerHTML = '';

      const row1 = document.createElement('div');
      row1.className = 'ap-line';
      let typeLabel = '—';
      if (line === 'mrirt') typeLabel = 'Mrirt';
      else if (line === 'beni_ouarain') typeLabel = 'Beni Ouarain';
      else if (line === 'azilal') typeLabel = 'Azilal';
      row1.innerHTML = `<div class="k">Type</div><div>${typeLabel}</div>`;
      recapBox.appendChild(row1);

      const row2 = document.createElement('div');
      row2.className = 'ap-line';
      row2.innerHTML = `<div class="k">Dimensions</div><div>${L && W ? `${L} × ${W} cm · ${area.toFixed(2)} m²` : '—'}</div>`;
      recapBox.appendChild(row2);

      const row3 = document.createElement('div');
      row3.className = 'ap-line';
      row3.innerHTML = `
        <div class="k">Accompagnement design</div>
        <div>${hasConfig ? 'Inclus' : '—'}</div>
      `;
      const subDesign = document.createElement('div');
      subDesign.className = 'ap-sub';
      subDesign.textContent = 'Maquette & suivi';
      const designLabel = row3.querySelector('.k');
      if (designLabel) {
        designLabel.appendChild(subDesign);
      } else {
        row3.appendChild(subDesign);
      }
      recapBox.appendChild(row3);

      const LABELS = {
        fringes: {
          classiques: 'Franges Classiques',
          torsadees: 'Franges Torsadées',
          bord_tisse: 'Bord Tissé'
        },
        symmetry: {
          asym: 'Style Libre (Asymétrique)',
          sym: 'Symétrie Parfaite',
          modern: 'Symétrie Moderne'
        },
        edge: {
          surjet: 'Finition Simple (Surjet)',
          galon: 'Bordure Tissée (Galon)'
        }
      };

      const row4 = document.createElement('div');
      row4.className = 'ap-line';
      const finText = optsHT ? fmtEur(optsHT) : 'Inclus';
      row4.innerHTML = `<div class="k">Finitions</div><div>${finText}</div>`;

      const subF = document.createElement('div');
      subF.className = 'ap-sub';
      subF.textContent =
        `${LABELS.fringes[fringe] || fringe} · ` +
        `${LABELS.edge[edge] || edge} · ` +
        `${LABELS.symmetry[sym] || sym}`;

      const kDiv = row4.querySelector('.k');
      if (kDiv) {
        kDiv.appendChild(subF);
      } else {
        row4.appendChild(subF);
      }
      recapBox.appendChild(row4);

      const row5 = document.createElement('div');
      row5.className = 'ap-line';
      row5.innerHTML = `<div class="k">Couleurs</div>`;
      const colorsWrap = document.createElement('div');
      colorsWrap.className = 'ap-colors';

      selectedColors.forEach(code => {
        const c = getColorByCode(code);
        const b = document.createElement('span');
        b.className = 'b';
        b.style.background = c.hex || '#ccc';
        b.title = (c.name ? c.name + ' — ' : '') + (c.code || code);
        colorsWrap.appendChild(b);
      });

      row5.appendChild(colorsWrap);
      recapBox.appendChild(row5);

      totalVal.textContent = totalHT > 0
        ? fmtEur(Math.round(totalTTC))
        : '—';
      return;
    }

    const L = Number(lengthInput && lengthInput.value ? lengthInput.value : 0);
    const W = Number(widthInput && widthInput.value ? widthInput.value : 0);
    const area = Math.max(0, (L * W) / 10000);

    const line = (form.querySelector('input[name="weave_line"]:checked') || {}).value || null;
    const rate = line ? (PRICING.rate_m2[line] || 0) : 0;
    const hasDims = L > 0 && W > 0;
    const baseHT = area * rate;

    const fringe = (form.querySelector('input[name="fringes"]:checked') || {}).value || 'classiques';
    const edge = (form.querySelector('input[name="edge"]:checked') || {}).value || 'surjet';
    const sym = (form.querySelector('input[name="symmetry"]:checked') || {}).value || 'sym';

    const addFrHT = (PRICING.finishes.fringes?.[fringe] || 0);
    const addEdHT = (PRICING.finishes.edge?.[edge] || 0);
    const addSymHT = (PRICING.finishes.symmetry?.[sym] || 0);
    const optsHT = addFrHT + addEdHT + addSymHT;

    const designHT = (PRICING.INCLURE_FORFAIT_DESIGN && hasDims) ? PRICING.FORFAIT_DESIGN : 0;
    const shipHT = PRICING.FRAIS_TRANSPORT_INCLUS || 0;

    const totalHT = Math.max(0, baseHT + optsHT + designHT + shipHT);
    const totalTTC = totalHT * (1 + PRICING.TVA);
    const totalAff = roundTo9(PRICING.ARRONDI_TTC, totalTTC);

    const LABELS = {
      fringes: {
        classiques: 'Franges Classiques',
        torsadees: 'Franges Torsadées',
        bord_tisse: 'Bord Tissé'
      },
      symmetry: {
        asym: 'Style Libre (Asymétrique)',
        sym: 'Symétrie Parfaite',
        modern: 'Symétrie Moderne'
      },
      edge: {
        surjet: 'Finition Simple (Surjet)',
        galon: 'Bordure Tissée (Galon)'
      }
    };

    const typeText = line ? (line === 'mrirt' ? 'Mrirt' : line === 'beni_ouarain' ? 'Beni Ouarain' : 'Azilal') : '—';
    const dimsText = (L && W) ? `${L} × ${W} cm · ${area.toFixed(2)} m²` : '—';

    const colorNames = selectedColors.map(code => {
      const c = getColorByCode(code);
      if (!c) return code;
      if (c.name && c.code) return `${c.name} (${c.code})`;
      return c.name || c.code || code;
    }).filter(Boolean).join(' · ');

    const bubbles = document.createElement('div'); bubbles.className = 'ap-colors';
    selectedColors.forEach(code => {
      const c = getColorByCode(code);
      const b = document.createElement('span'); b.className = 'b'; b.style.background = c.hex || '#ccc';
      b.title = (c.name ? c.name + ' — ' : '') + code;
      bubbles.appendChild(b);
    });

    recapBox.innerHTML = '';

    (function () {
      const row = document.createElement('div'); row.className = 'ap-line';
      row.innerHTML = `<div class="k">Type</div><div>${typeText}</div>`;
      recapBox.appendChild(row);
    })();

    (function () {
      const row = document.createElement('div'); row.className = 'ap-line';
      row.innerHTML = `<div class="k">Dimensions</div><div>${dimsText}</div>`;
      recapBox.appendChild(row);
    })();

    (function () {
      const row = document.createElement('div'); row.className = 'ap-line';
      const left = document.createElement('div'); left.innerHTML = `<div class="k">Accompagnement Design</div><div class="ap-sub">Maquette et suivi</div>`;
      const right = document.createElement('div'); right.textContent = 'Inclus';
      row.append(left, right);
      recapBox.appendChild(row);
    })();

    (function () {
      const row = document.createElement('div'); row.className = 'ap-line fins';
      const left = document.createElement('div'); left.innerHTML = `<div class="k">Finitions</div>`;

      const desktop = document.createElement('div');
      desktop.className = 'ap-sub ap-sub-desktop-only';
      desktop.textContent = `${LABELS.fringes[fringe] || fringe} · ${LABELS.edge[edge] || edge} · ${LABELS.symmetry[sym] || sym}`;

      const m1 = document.createElement('div'); m1.className = 'ap-sub ap-sub-mobile-only'; m1.textContent = `${LABELS.fringes[fringe] || fringe}`;
      const m2 = document.createElement('div'); m2.className = 'ap-sub ap-sub-mobile-only'; m2.textContent = `${LABELS.edge[edge] || edge}`;
      const m3 = document.createElement('div'); m3.className = 'ap-sub ap-sub-mobile-only'; m3.textContent = `${LABELS.symmetry[sym] || sym}`;

      left.append(desktop, m1, m2, m3);

      const right = document.createElement('div');
      right.textContent = optsHT > 0 ? fmtEur(optsHT) : 'Inclus';

      row.append(left, right);
      recapBox.appendChild(row);
    })();

    (function () {
      const row = document.createElement('div'); row.className = 'ap-line';
      const left = document.createElement('div');
      const k = document.createElement('div'); k.className = 'k'; k.textContent = 'Couleurs';
      const sub = document.createElement('div'); sub.className = 'ap-sub ap-color-names';
      sub.textContent = colorNames || '—';
      k.appendChild(sub);
      left.appendChild(k);
      row.append(left, bubbles);
      recapBox.appendChild(row);
    })();

    (function () {
      const row = document.createElement('div'); row.className = 'ap-line';
      row.innerHTML = `<div class="k">Transport</div><div>${shipHT ? fmtEur(shipHT) : 'offert'}</div>`;
      recapBox.appendChild(row);
    })();

    totalVal.textContent = fmtEur(totalAff);
  }

  /* =============== INIT =============== */
  function wireSavedState() {
    try {
      const saved = localStorage.getItem('atelier_des_possibles_v1');
      if (!saved) return;
      const o = JSON.parse(saved);
      Object.keys(o).forEach(k => {
        const el = form.elements[k]; if (!el) return;
        if (el instanceof RadioNodeList) { [...el].forEach(r => { if (r.value == o[k]) r.checked = true; }); }
        else { el.value = o[k]; }
      });
    } catch (e) { }
  }

  function setDefaultIfEmpty(groupName, value) {
    const group = form.querySelectorAll(`input[name="${groupName}"]`);
    if (![...group].some(i => i.checked)) {
      const target = form.querySelector(`input[name="${groupName}"][value="${value}"]`);
      if (target) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  function applyDefaultFinishesIfEmpty() {
    setDefaultIfEmpty('fringes', 'standard');
    setDefaultIfEmpty('symmetry', 'sym');
    setDefaultIfEmpty('edge', 'overlock');
  }

  function init() {
    if (agenda) agenda.classList.add('ap-hidden');
    setStep(1, { skipScroll: true });

    [3, 4, 5, 6, 7, 9].forEach(n => {
      const p = document.querySelector(`[data-ap-panel="${n}"]`);
      if (p) setupInfoToggles(p);
    });
    morphInfoButtonsToI();

    // Nuancier
    loadNuancier();

    // Finitions
    applyOptionPrices();
    bubbleSelect(fringeBubbles, 'fringes');
    bubbleSelect(symmetryBubbles, 'symmetry');
    bubbleSelect(edgeBubbles, 'edge');

    // Recalculs
    ['ap-length', 'ap-width'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.addEventListener('input', computeAndRenderQuote);
    });
    form.querySelectorAll('input[name="weave_line"]').forEach(r => r.addEventListener('change', computeAndRenderQuote));

    // Fichiers croquis
    wireFileInputs();

    wireSavedState();
    applyDefaultFinishesIfEmpty();
    renderAllFinishPreviews();
    computeAndRenderQuote();
  }

  init();
  window.addEventListener('resize', centerActivePill);
})();
